import * as React from 'react'

import { SelectedOptions } from '@thg-commerce/enterprise-network/src/ApolloProvider/resolvers/Query/Product/ProductPage'
import { ProductVariantWithDescription } from '@thg-commerce/enterprise-network/src/ApolloProvider/resolvers/Types/Product'
import { sanitizeCookie } from '@thg-commerce/enterprise-utils'

import { ProductPageContext } from './ProductPageContext'
import { ProductPageContextInterface } from './types'

const RECENTLY_VIEWED_PRODUCTS_COOKIE = 'recentlyViewedProducts'

export const ProductPageContextProvider: React.FunctionComponent<{
  product: NonNullable<ProductPageContextInterface['product']>
  manualRecommendations:
    | ProductPageContextInterface['manualRecommendations']
    | null
  variationSkuProduct?: ProductVariantWithDescription
}> = (props) => {
  // @TODO: REBUILD-8913 can simplify when using new product options
  const [selectedVariant, setSelectedVariant] = React.useState<
    ProductVariantWithDescription
  >(() => {
    return !props.variationSkuProduct
      ? props.product.defaultVariant
      : props.variationSkuProduct
  })

  const [activeTabIndex, setActiveTabIndex] = React.useState<number>(0)
  const [storeStockActive, setStoreStockActive] = React.useState<boolean>(false)
  // @TODO: REBUILD-8913 can simplify when using new product options
  const [selectedOptions, setSelectedOptions] = React.useState<SelectedOptions>(
    props.product.selectedOptions
      ? props.product.selectedOptions
      : selectedVariant.choices.reduce<SelectedOptions>(
          (accumulator, choice) => {
            accumulator[choice.optionKey] = choice.key
            return accumulator
          },
          {},
        ),
  )

  const recentlyViewedSkus = React.useMemo(
    () => new Set<string>(parseRecentProductsCookie(props.product?.sku)),
    [props.product.sku],
  )

  const outOfStockEnabledProducts = props.product.variants.map((variant) => {
    if (variant.inStock === false && variant.notifyWhenInStockEnabled) {
      return true
    }
    return false
  })

  const showNotifyWhenOutOfStockInDropdown = outOfStockEnabledProducts.includes(
    true,
  )

  return (
    <ProductPageContext.Provider
      value={{
        storeStockActive,
        setStoreStockActive,
        recentlyViewedSkus,
        selectedVariant,
        showNotifyWhenOutOfStockInDropdown,
        setSelectedVariant,
        setSelectedOptions,
        selectedOptions,
        activeTabIndex,
        setActiveTabIndex,
        preselectVariant: props.preselectVariant,
        presentImageGalleryZoomModal: React.useRef(() => {}),
        defaultVariant: props.product.defaultVariant,
        product: props.product,
        manualRecommendations: props.manualRecommendations,
        enableHullabalookRecommendations:
          props.enableHullabalookRecommendations,
      }}
    >
      {props.children}
    </ProductPageContext.Provider>
  )
}

const parseRecentProductsCookie = (currentSku: number) => {
  const sku = currentSku.toString()
  const sanitizedValue = sanitizeCookie(RECENTLY_VIEWED_PRODUCTS_COOKIE)
  const productSkus: string[] = sanitizedValue ? sanitizedValue.split(',') : []

  if (productSkus.includes(sku)) {
    productSkus.splice(productSkus.indexOf(sku), 1)
  }
  return productSkus
}
